import React from 'react';
import styled from 'styled-components';

import imgClose from 'src/assets/images/close-on-orange.svg';

export const VideoPopUp = ({ onClick, videoLink, fileExtension }) => {
  return (
    <StyledPopUp>
      <StyledBackground onClick={onClick}></StyledBackground>
      <StyledContentWindow>
        <StyledVideoEmbed
          controls
          autoPlay
          playsInline
          src={videoLink}
          media={`video/${fileExtension}`}
        ></StyledVideoEmbed>
      </StyledContentWindow>

      <StyledButton onClick={onClick}>
        <span>Close</span>
        <img src={imgClose} alt="Close Menu" />
      </StyledButton>
    </StyledPopUp>
  );
};

const StyledPopUp = styled.div`
  z-index: 990;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (orientation: landscape) and (max-height: 569px) {
    justify-content: space-between;
  }

  /* background-color: ${({ theme }) => `${theme.colorDarkBlue + '80'}`}; */
`;

const StyledContentWindow = styled.div`
  z-index: 998;
  width: 90%;
  @media (min-width: 1399px) {
    width: 80%;
  }
  @media (orientation: landscape) and (max-height: 569px) {
    margin-top: 3%;
    max-width: 90%;
  }
  @media (orientation: landscape) and (max-height: 415px) {
    max-width: 60%;
  }
  @media (min-width: 1945px) {
    width: 70%;
  }
`;

const StyledVideoEmbed = styled.video`
  z-index: 999;
  width: 100%;
`;

const StyledButton = styled.div`
  color: rgba(255, 255, 255, 0.83);
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 30px;
  position: absolute;
  cursor: pointer;
  transition: 0.4s ease-out;
  z-index: 99999;
  width: 105px;
  height: 35px;
  text-transform: uppercase;
  position: fixed;
  bottom: 30px;
  background-color: ${({ theme }) => theme.colorPrimary};
  font-family: ${({ theme }) => theme.fontHeader};
  &:hover {
    /* background-color: ${({ theme }) => theme.colorDarkBlue}; */
    box-shadow: 0 0 8px 0 rgba(255, 120, 2, 0.55);
  }

  @media (max-height: 568px) {
    bottom: 3%;
  }
`;

const StyledBackground = styled.div`
  background-color: ${({ theme }) => `${theme.colorDarkBlue}`};
  opacity: 0.8;
  z-index: 800;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
`;



// WEBPACK FOOTER //
// ./src/components/VideoPopUp.js